import { render } from "./Header.vue?vue&type=template&id=33c48a5f&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=33c48a5f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\SMFBackstageBase\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c48a5f"]])

export default __exports__